import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_tekton.png",
      alt: "Estratégias Tekton AI",
    },
    title:
      "Tekton AI: Revolucione Seus Investimentos com Inteligência Artificial",

    // String ou array de strings
    text: [
      "A Tekton AI se destaca no mercado financeiro ao implementar o Deep Reinforcement Learning (DRL), uma técnica de ponta em inteligência artificial que une o aprendizado profundo (deep learning) com o aprendizado por reforço (reinforcement learning). Esta metodologia avançada permite que nosso sistema não apenas aprenda a partir de vastas quantidades de dados, mas também tome decisões estratégicas complexas. Utilizando agentes treinados com o DRL — fruto de mais de 5 anos de pesquisa e desenvolvimento — a Tekton AI é capaz de identificar com precisão os melhores momentos para comprar ou vender ativos, ajustando-se automaticamente às mudanças do mercado para maximizar os retornos dos investimentos e minimizar os riscos.",
      "O coração da nossa tecnologia é um agente de DRL, resultado dessa extensa pesquisa e desenvolvimento, treinado e especializado em cada ação e setor do mercado. Este agente analisa continuamente todos os indicadores técnicos e fundamentalistas que podem impactar na performance daquela ação. Diferente de outras abordagens, o DRL possibilita uma adaptação contínua e aprendizado a partir da interação direta com o mercado, garantindo que a Tekton AI não apenas responda às condições atuais, mas também antecipe movimentos futuros, oferecendo uma abordagem de investimento dinâmica e proativa.",
    ],
    testimonial: {
      text: "Nossa IA analisa milhares de dados em segundos, superando a capacidade humana e maximizando decisões de investimento com precisão inigualável.",
      author: {
        name: "Roberto Fix Ventura, CEO da Tekton AI.",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Tekton AI Ações",
    heading: "Deep Reinforcement Learning Aplicado à Investimentos ",
    subtitle:
      "Estratégia pronta para utilização e em contínuo aperfeiçoamento, fruto de mais de 5 anos de pesquisa e desenvolvimento",
  },

  cta: {
    title: "Invista com segurança.",
    subtitle: "Ative agora mesmo. Deixe a Tekton AI trabalhar para você.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Tekton Finance",
    col1: [
      "Tekton Finance é uma empresa que se especializa no fornecimento de soluções de software avançadas para gestão de portfólios, utilizando inteligência artificial para potencializar assessores financeiros, gestores de ativos e investidores avançados. Desde 2019, com endereço em Nova Iorque, EUA, e um escritório em São Paulo, Brasil, a Tekton oferece uma gama de aplicações SaaS (Software como um Serviço) para gestão de portfólios, fundamentadas em pesquisas profundas sobre novas tecnologias inovadoras. Essas ferramentas são desenhadas para serem abrangentes, fáceis de usar e escaláveis, habilitando os usuários a construir e gerenciar portfólios de forma mais eficaz, gerando alfa superior, isto é, retornos acima da média do mercado, com menor risco e volatilidade.",
      "A empresa se diferencia no mercado de gestão de ativos, que tem visto um crescimento substancial ao longo da última década, alcançando dezenas de trilhões de dólares em ativos sob gestão (AUM). Tekton posiciona suas soluções de gestão de portfólios com IA no centro da transformação digital no setor financeiro, onde assessores financeiros e investidores avançados desempenham papéis cruciais. A demanda por soluções inovadoras de gestão de portfólios movidas a IA está em ascensão, impulsionada pela necessidade de analisar grandes volumes de dados, otimizar decisões de investimento e aprimorar a gestão de riscos. Tekton se destaca por meio de suas ferramentas de gestão de portfólios inovadoras e integradas via API com corretoras, combinando tecnologia de ponta com uma experiência de usuário intuitiva para ajudar seus clientes a otimizar seus portfólios e alcançar retornos superiores. ",
      "No núcleo da oferta da Tekton está a utilização de Aprendizado por Reforço Profundo (Deep Reinforcement Learning - DRL), uma ramificação da IA que permite às máquinas aprenderem e se adaptarem a partir de experiências para tomar decisões melhores ao longo do tempo. Essa abordagem permite a análise de uma vasta quantidade de dados relacionados a títulos e fundamentos econômicos, criando agentes inteligentes que sugerem os pesos ótimos dos portfólios. Além dos benefícios diretos, como desempenho aprimorado do portfólio e gestão de riscos mais eficaz, a Tekton visa a transformação a longo prazo da gestão de portfólios com suas soluções de IA, aumentando a eficiência, reduzindo a necessidade de intervenção manual e permitindo uma gestão adaptativa de portfólios em diversos cenários de mercado.",
    ],
    col2: [
      // "Nosso compromisso com a qualidade é inegociável. Cada robô trader desenvolvido pela SigmaSix passa por rigorosos testes e análises para garantir seu desempenho e eficácia. Nosso objetivo é oferecer soluções que não apenas atendam, mas excedam as expectativas de nossos clientes.",
      // "Além disso, reconhecemos que cada investidor é único, com suas próprias necessidades e objetivos. Por isso, oferecemos soluções personalizadas e adaptadas às preferências e metas individuais de cada cliente. Nosso foco é sempre fornecer resultados tangíveis que ajudem nossos clientes a alcançar seus objetivos financeiros. ",
      // "A SigmaSix é mais do que uma empresa de tecnologia financeira. Somos uma comunidade de investidores, inovadores e visionários, unidos por uma paixão compartilhada pelo sucesso financeiro. Estamos comprometidos em construir um futuro onde todos tenham acesso a ferramentas e recursos que os capacitem a alcançar a liberdade financeira. Junte-se a nós e descubra o que a SigmaSix pode fazer por você.",
    ],
  },

  stats: {
    title: "Tekton Finance em Números",
    subtitle:
      "Desde 2019 desenvolvendo sistemas de Deep Reinforcement Learning (DRL) aplicados a Investimentos.",
    data: [
      {
        value: "+5",
        description: "Anos de P&D em DRL",
      },
      {
        value: "+32.5k",
        description:
          "CPUs analisando dados 24 horas por dia, 7 dias por semana",
      },
      {
        value: "+20k",
        description: "Modelos de AI criados",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Tekton?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.code,
        title: "Adaptação Dinâmica ao Mercado",
        description:
          "Os sistemas DRL da Tekton AI aprendem e adaptam-se continuamente às mudanças do mercado, permitindo reações rápidas e precisas a novas informações e tendências, sem a necessidade de intervenção humana.",
      },
      {
        icon: iconsSet.iconTabDetails,
        title: "Decisões Baseadas em Dados Volumosos",
        description:
          "Eles podem processar e analisar quantidades massivas de dados - muito além do que é humanamente possível - para tomar decisões de investimento informadas, maximizando as chances de sucesso.",
      },
      {
        icon: iconsSet.paper_board,
        title: "Minimização de Riscos",
        description:
          "Através do aprendizado constante, os sistemas DRL identificam padrões de risco e ajustam as estratégias para minimizar perdas, protegendo o capital investido.",
      },
      {
        icon: iconsSet.backtest,
        title: "Maximização de Retornos",
        description:
          "Ao identificar oportunidades de mercado com alta precisão, os sistemas DRL da Tekton otimizam as entradas e saídas de operações, visando maximizar os retornos dos investimentos.",
      },
      {
        icon: iconsSet.clock,
        title: "Operações 24/7",
        description:
          "Diferentemente dos operadores humanos, os sistemas DRL podem monitorar e operar no mercado de forma contínua, sem interrupções, aproveitando oportunidades que ocorrem fora do horário comercial tradicional.",
      },
      {
        icon: iconsSet.editParams,
        title: "Customização e Especialização",
        description:
          "Cada agente DRL é treinado e especializado em determinados setores ou ações do mercado, o que permite uma compreensão profunda e estratégias customizadas para maximizar os resultados em áreas específicas de investimento.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Colaborei com Tekton e Roberto para desenvolver uma ferramenta de otimização de portfólio melhor para a Rational Investment Methodology (uma empresa de assessoria de investimentos registradas nos EUA, que gerencia portfólios de ações específicos - e altamente complexos - para seus clientes). Suas habilidades de programação e análise são incomparáveis. Acredito que você não ficaria decepcionado ao trabalhar com a Tekton.",
      author: "Danilo Santiago",
      job: "Investment Advisor (Rational Investment Methodology, New York, USA)",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Tive o prazer de trabalhar com Tekton e Roberto na construção de modelos estruturados para implantação com meus clientes. As habilidades técnicas de Roberto foram fundamentais para nós desenvolvermos uma aplicação altamente pragmática e funcional que ajudou a otimizar a carga de trabalho da minha empresa e a entregar melhores resultados de investimento para clientes exigentes. A Tekton esteve altamente engajada em resolver nossos problemas com ferramentas superiores de modelagem e negociação automatizadas.",
      author: "Brett Janis",
      job: "Investment Advisor (Strong Bridge Advisers, San Francisco, USA)",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
